var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "c-logo",
      class: { "-white": _vm.isWhite },
      attrs: {
        width: _vm.width,
        viewBox: "0 0 115 25",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    },
    [
      _c("title", [_vm._v("logo copy")]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Page-1",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Desktop-/-Home",
                transform: "translate(-663.000000, -30.000000)"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "logo-1",
                    transform: "translate(663.000000, 30.000000)"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "Group",
                        transform: "translate(32.326913, 2.338129)",
                        fill: "#202950",
                        "fill-rule": "nonzero"
                      }
                    },
                    [
                      _c("polygon", {
                        attrs: {
                          id: "Path",
                          points:
                            "12.9606976 6.12709832 8.15356585 6.12709832 3.99297241 11.4808153 3.99297241 0.79736211 0.0119729308 0.79736211 0.0119729308 19.9820144 3.99297241 19.9820144 3.99297241 14.442446 8.42295679 19.9820144 13.1223321 19.9820144 7.39328475 12.9736211"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M23.1137428,7.26019185 C22.0780843,6.25899281 20.7191567,5.75539568 19.0549193,5.75539568 C17.211088,5.75539568 15.6127017,6.46882494 14.2956793,7.87769784 C12.9846434,9.28057554 12.3201458,11.0251799 12.3201458,13.057554 C12.3201458,15.0899281 12.9846434,16.8345324 14.2956793,18.2374101 C15.6127017,19.646283 17.211088,20.3597122 19.0549193,20.3597122 C20.7191567,20.3597122 22.0780843,19.8561151 23.1137428,18.8549161 L23.1137428,19.9880096 L27.0887559,19.9880096 L27.0887559,6.12709832 L23.1137428,6.12709832 L23.1137428,7.26019185 Z M22.1439355,10.5455635 C22.7964602,11.1990408 23.1137428,12.0203837 23.1137428,13.0515588 C23.1137428,14.088729 22.7964602,14.9040767 22.1439355,15.557554 C21.4914107,16.2110312 20.6892244,16.528777 19.6894846,16.528777 C18.6897449,16.528777 17.893545,16.2110312 17.2529932,15.557554 L17.2529932,15.557554 C16.606455,14.9040767 16.2951588,14.0827338 16.2951588,13.0455635 C16.2951588,12.0083933 16.606455,11.1870504 17.2529932,10.5335731 C17.8995315,9.88009592 18.6957314,9.56235012 19.6894846,9.56235012 C20.6892244,9.57434053 21.4914107,9.89208633 22.1439355,10.5455635 Z",
                          id: "Shape"
                        }
                      }),
                      _vm._v(" "),
                      _c("rect", {
                        attrs: {
                          id: "Rectangle",
                          x: "29.6569495",
                          y: "0",
                          width: "3.97501301",
                          height: "19.9820144"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M42.8271733,5.74940048 C40.7019781,5.74940048 38.9419573,6.45083933 37.5830297,7.84172662 C36.224102,9.22661871 35.5356585,10.9832134 35.5356585,13.0515588 C35.5356585,15.1378897 36.236075,16.9004796 37.6069755,18.2793765 C38.9838626,19.6582734 40.8276939,20.353717 43.0905778,20.353717 C45.7246226,20.353717 47.7540344,19.352518 49.112962,17.3860911 L49.280583,17.1402878 L46.0478917,15.2757794 L45.9042166,15.4676259 C45.2816242,16.2889688 44.3776679,16.6906475 43.144456,16.6906475 C41.3784487,16.6906475 40.2709526,16.0491607 39.774076,14.736211 L49.6517439,14.736211 L49.6936491,14.5083933 C49.7834461,13.998801 49.8313378,13.5071942 49.8313378,13.0515588 C49.8313378,11.001199 49.1668402,9.25659472 47.8558043,7.85971223 C46.5327954,6.46282974 44.8446122,5.74940048 42.8271733,5.74940048 Z M40.7079646,10.0359712 C41.2587194,9.60431655 41.9711088,9.38848921 42.8271733,9.38848921 C43.5455492,9.38848921 44.1920875,9.59232614 44.7548152,10 C45.2337324,10.3477218 45.574961,10.8573141 45.7725143,11.528777 L39.7022384,11.528777 C39.8997918,10.9052758 40.2350338,10.4016787 40.7079646,10.0359712 Z",
                          id: "Shape"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M62.1874024,7.25419664 C61.1697033,6.25899281 59.8167621,5.75539568 58.1525247,5.75539568 C56.290734,5.75539568 54.6803748,6.46882494 53.3693389,7.87769784 C52.058303,9.28057554 51.3938053,11.0251799 51.3938053,13.057554 C51.3938053,15.0899281 52.058303,16.8345324 53.3693389,18.2374101 C54.6863613,19.646283 56.2967205,20.3597122 58.1525247,20.3597122 C59.8107756,20.3597122 61.1637168,19.8561151 62.1874024,18.8609113 L62.1874024,19.9880096 L66.1624154,19.9880096 L66.1624154,0.803357314 L62.1874024,0.803357314 L62.1874024,7.25419664 Z M58.7930765,16.5347722 C57.7933368,16.5347722 56.9911504,16.2170264 56.3386257,15.5635492 C55.686101,14.9100719 55.3688183,14.088729 55.3688183,13.057554 C55.3688183,12.0203837 55.686101,11.205036 56.3386257,10.5515588 C56.9911504,9.89808153 57.7933368,9.58033573 58.7930765,9.58033573 C59.7868298,9.58033573 60.5890161,9.89808153 61.2295679,10.5515588 C61.8761062,11.205036 62.1874024,12.0263789 62.1874024,13.0635492 C62.1874024,14.1007194 61.8761062,14.9220624 61.2295679,15.5755396 C60.5830297,16.2170264 59.7868298,16.5347722 58.7930765,16.5347722 Z",
                          id: "Shape"
                        }
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d:
                            "M80.5478917,7.86570743 C79.1350859,6.46282974 77.387038,5.74940048 75.3576262,5.74940048 C73.322228,5.74940048 71.5801666,6.46282974 70.1793337,7.86570743 C68.7785008,9.26858513 68.0661114,11.0131894 68.0661114,13.0515588 C68.0661114,15.0899281 68.7785008,16.8345324 70.1793337,18.2374101 C71.5801666,19.6402878 73.322228,20.353717 75.3576262,20.353717 C77.3930245,20.353717 79.1350859,19.6402878 80.5478917,18.2374101 L80.5478917,18.2374101 C81.9606976,16.8345324 82.6730869,15.0899281 82.6730869,13.0515588 C82.6730869,11.0191847 81.9547111,9.27458034 80.5478917,7.86570743 Z M78.6980739,13.057554 C78.6980739,14.058753 78.3867777,14.8561151 77.7402395,15.4976019 C77.0937012,16.1450839 76.3154607,16.4568345 75.3576262,16.4568345 C74.3938053,16.4568345 73.6215513,16.1450839 72.9869859,15.4976019 C72.3524206,14.8501199 72.0411244,14.0527578 72.0411244,13.0515588 C72.0411244,12.0503597 72.3524206,11.2529976 72.9869859,10.6055156 C73.6215513,9.96402878 74.3938053,9.64628297 75.3576262,9.64628297 C76.3214472,9.64628297 77.0996877,9.95803357 77.7402395,10.6055156 C78.3807913,11.2589928 78.6980739,12.0563549 78.6980739,13.057554 Z",
                          id: "Shape"
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("g", { attrs: { id: "Group" } }, [
                    _c("path", {
                      attrs: {
                        d:
                          "M6.27980219,0.0599520384 C2.84357106,0.0599520384 0.0598646538,2.84772182 0.0598646538,6.28896882 L0.0598646538,18.7470024 C0.0598646538,22.1882494 2.84357106,24.9760192 6.27980219,24.9760192 C9.71603332,24.9760192 12.4997397,22.1882494 12.4997397,18.7470024 L12.4997397,6.28896882 C12.4997397,2.84772182 9.71603332,0.0599520384 6.27980219,0.0599520384 Z M8.8539823,18.7470024 C8.8539823,20.1738609 7.69859448,21.32494 6.27980219,21.32494 C4.85502343,21.32494 3.70562207,20.1678657 3.70562207,18.7470024 L3.70562207,6.28896882 C3.70562207,4.86211031 4.86100989,3.71103118 6.27980219,3.71103118 C7.70458095,3.71103118 8.8539823,4.86810552 8.8539823,6.28896882 L8.8539823,18.7470024 Z",
                        id: "Shape",
                        fill: "#FF6362"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M23.1137428,1.882494 C20.6832379,-0.551558753 16.7441437,-0.551558753 14.3196252,1.882494 L1.87975013,14.3405276 C-0.550754815,16.7745803 -0.550754815,20.7194245 1.87975013,23.147482 C4.31025508,25.5755396 8.2493493,25.5815348 10.6738678,23.147482 L23.1137428,10.6894484 C25.5442478,8.26139089 25.5442478,4.31654676 23.1137428,1.882494 Z M8.09968766,20.5695444 C7.09396148,21.5767386 5.45965643,21.5767386 4.45393024,20.5695444 C3.44820406,19.5623501 3.44820406,17.9256595 4.45393024,16.9184652 L16.8938053,4.46642686 C17.8995315,3.45923261 19.5338365,3.45923261 20.5395627,4.46642686 C21.5452889,5.4736211 21.5452889,7.11031175 20.5395627,8.117506 L8.09968766,20.5695444 Z",
                        id: "Shape",
                        fill: "#00B2E3",
                        "fill-rule": "nonzero"
                      }
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d:
                          "M18.7196773,12.5179856 C15.2834461,12.5179856 12.4997397,15.3057554 12.4997397,18.7470024 C12.4997397,22.1882494 15.2834461,24.9760192 18.7196773,24.9760192 C22.1559084,24.9760192 24.9396148,22.1882494 24.9396148,18.7470024 C24.9396148,15.3057554 22.1559084,12.5179856 18.7196773,12.5179856 Z M18.7196773,21.32494 C17.2948985,21.32494 16.1454971,20.1678657 16.1454971,18.7470024 C16.1454971,17.3201439 17.300885,16.1690647 18.7196773,16.1690647 C20.144456,16.1690647 21.2938574,17.3261391 21.2938574,18.7470024 C21.2938574,20.1738609 20.144456,21.32494 18.7196773,21.32494 Z",
                        id: "Shape",
                        fill: "#FFD200"
                      }
                    })
                  ])
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b672cfe6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b672cfe6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CLogo.vue
// module id = Hhy6
// module chunks = 1624